const { Button } = require('@material-tailwind/react')
const { FiUpload } = require('react-icons/fi')

export const MassiveUploadButton = () => {
  return (
    <Button
      variant='outlined'
      className='flex items-center gap-3 whitespace-nowrap'
      color='white'
    >
      <FiUpload size='1rem' />
      Carga Masiva
    </Button>
  )
}
